<template>
  <div class="c-table" ref="lifecycletable">
    <Spin size="large" fix v-if="loading" />
    <div v-if="queryType">
      <h3 v-if="queryType === 1">【分日统计方式】</h3>
      <h3 v-else-if="queryType === 2">【分周统计方式】</h3>
      <h3 v-else-if="queryType === 3">【分月统计方式】</h3>
      <h3 v-else>【汇总统计方式】</h3>
    </div>
    <el-table
      class="common-el-table-styles summary-el-table-styles"
      ref="table"
      border
      stripe
      show-summary
      :data="data"
      :summary-method="summary"
      v-on="$listeners"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'tdate'">
            {{ scope.row.tdateDesc }}
          </span>
          <span v-else-if="col.key === 'labelName'">
            <el-button type="text" @click="toMaterialReportPage(scope.row)">{{ scope.row.labelName }}</el-button>
          </span>
          <span
            v-else-if="
              [
                'pv',
                'clickNum',
                'paperUseAmount',
                'amount',
                'newRoleMoney',
                'sumRecharge',
                'sumMoney',
                'downNum',
                'newUserNum',
                'createRoleNum',
                'newRoleNum',
                'payRoleUserNum',
                'timeDiff'
              ].includes(col.key)
            "
            >{{ scope.row[col.key] | toThousands }}</span
          >
          <span v-else-if="col.key.indexOf('Rate') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="getPercent(col.key)">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import mixin from '../mixin'
export default {
  name: '',
  mixins: [mixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Function
    },
    height: {
      type: Number
    },
    queryType: {
      // 内容标签曲线和分日数据曲线共用本组件，内容标签曲线需要显示统计方式相关业务
      // 截止4.29.2 如果queryType没有值，那么就是在分日数据曲线使用本组件
      type: Number
    },
    filterData: {
      // 点击内容标签曲线页面table列标签调整到素材分析需要传递查询参数
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    getPercent(key) {
      if (['createRole24hRoi', 'createRoleRoi1d', 'createRoleRoi3d', 'createRoleRoi7d'].includes(key)) return true
      return key.indexOf('Retain') > -1
    },
    toMaterialReportPage(row) {
      this.$router.push({
        name: 'reportMaterialAnalysis',
        query: {
          labelId: row.labelId,
          ...this.filterData
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
}
</style>
